import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { IPiggyController } from "../../controller/IPiggyController";
import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";

export class BigPiggyComponent extends Container {
    private readonly piggyController: IPiggyController;

    private readonly piggy: Sprite;
    private readonly piggyInfoButton: ButtonWithScaleAnimation;

    public constructor(
        piggyController: IPiggyController,
        piggyResources: PiggyResourcePackage,
        piggyTexture: Texture,
        piggyInfoPos: Point
    ) {
        super();
        this.piggyController = piggyController;

        this.piggy = new Sprite(piggyTexture);
        this.piggyInfoButton = new ButtonWithScaleAnimation(piggyResources.assets_views_piggy_info_icon_png);
        this.piggyInfoButton.position.set(piggyInfoPos.x, piggyInfoPos.y);
        this.addChild(this.piggy, this.piggyInfoButton);

        this.piggyInfoButton.onUp.add(this.onInfoButtonClickHandle, this);
    }

    private async onInfoButtonClickHandle(): Promise<void> {
        this.piggyInfoButton.eventMode = 'auto';
        await this.piggyController.showPiggyInfo();
        this.piggyInfoButton.eventMode = 'static';
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.piggyInfoButton.onUp.remove(this.onInfoButtonClickHandle, this);
        super.destroy(options);
    }
}
